import { eEstadoTipoVisita } from "../common/enumModel";
import { ITipoVisitaModel } from "../interfaces/tipo-visita/ITipoVisitaModel";

export class TipoVisitaModel implements ITipoVisitaModel {
    idTipoVisita : number;
    nombre : string;
    idEstado: eEstadoTipoVisita;
    estado: string;
    defaulContratista: boolean;
    
    constructor(){
        this.idTipoVisita = 0;
        this.nombre = '';
        this.idEstado = eEstadoTipoVisita.ACTIVO;
        this.estado = '';
        this.defaulContratista = false
    }
}
